import { services } from '../data/services'
import ServiceCard from '../components/ServiceCard'
import SeoHead from '../components/SeoHead'

export default function Services() {
  return (
    <>
      <SeoHead
        title="Our Services — East County Business Center"
        description="Explore all services at East County Business Center in El Cajon, CA — virtual addresses, private offices, conference rooms, and flexible memberships."
        path="/services"
      />
      <section className="bg-ecbc-navy text-white py-20 px-6 text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Our Services</h1>
        <p className="text-white/75 max-w-2xl mx-auto text-lg">
          Office solutions for the new economy — pick what fits your business today, change as you grow.
        </p>
      </section>

      <section className="bg-white py-16 px-6">
        <h2 className="sr-only">All services</h2>
        <div className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {services.map((service) => (
            <ServiceCard
              key={service.id}
              icon={service.icon}
              title={service.title}
              price={service.price}
              description={service.shortDesc}
              to={`/services/${service.id}`}
            />
          ))}
        </div>
      </section>
    </>
  )
}
